import { useState } from "react";
import mainservice from "../../../services/MainService";
import PersonList from "../Person/PersonList";
import { PersonKind } from "../Person/PersonKind";
import LocationSelect from "../Location/LocationSelect";
import DateSelect from "../Calendar/DateSelect";
import { EventDTO } from "../../DTO/EventDTO";
import { EventSpecificEditFieldsStatus, EventSpecificEditFieldsSubjects, EventSpecificEditFieldsTopLeft, EventSpecificEditFieldsTopRight } from "../../editFields/EventSpecificEditFields1";
import { Status } from "../day/dayView";
import Spinner from "../../../components/Spinner/Spinner";
import BroadcastRightButton from "../../elements/BroadcastRightButton";
import { RightDrawerContent } from "../RightDrawer";
import EditFieldsPrinter from "../../editFields/EditFieldsPrinter";

export function PlaningDetails(props: {
  event: EventDTO;
}) {
  const Event = props.event;
  const [RerenderPersons, setRerenderPersons] = useState(0);
  const [status, setStatus] = useState(Status.standard);
  const [UserMsg, setUserMsg] = useState('');
  const [rerender, setRerender] = useState(0)
  const broadCastBackKeyPrincipalAdd = `EventPrincipalAddFor-${Event.id}`;
  const broadCastBackKeyTrainerAdd = `EventTrainerAddFor-${Event.id}`;
  const broadCastBackKeyPersonAdd = `EventPersonAddFor-${Event.id}`;
  const broadCastBackKeyLocationAdd = `EventLocationAddFor-${Event.id}`;
  const broadCastBackKeyCustomerAdd = `EventCustomerAddFor-${Event.id}`;
  const broadCastBackKeyCustomerLocationAdd = `EventCustomerLocationAddFor-${Event.id}`;
  const broadCastBackKeySeminarAdd = `EventSeminarAddFor-${Event.id}`;
  mainservice.registerToBroadcast(`EventEdit-${Event.id}`,
    async (key: string, _value: any) => {
      if (
        key === broadCastBackKeyPersonAdd ||
        key === broadCastBackKeyPrincipalAdd ||
        key === broadCastBackKeyTrainerAdd
      ) {
        let personKind: PersonKind = PersonKind.generic
        if (key === broadCastBackKeyPrincipalAdd) {
          personKind = PersonKind.principal
        } else if (key === broadCastBackKeyTrainerAdd) {
          personKind = PersonKind.trainer
        }
        setStatus(Status.loading);
        console.log('person ids', _value.personIds)
        for (let i = 0, m = _value.personIds.length; i < m; i++) {
          await Event.addPerson(_value.personIds[i], personKind);
        }
        // In diesem Fall bitte noch mal das Event laden, da es neue props gibt
        await Event.getFromServer()
        setStatus(Status.standard)
        setRerenderPersons(RerenderPersons + 1)
      }
      if (key === broadCastBackKeyLocationAdd) {
        setStatus(Status.loading);
        await Event.setLocation(_value.id as number);
        setStatus(Status.standard);
      }
      if (key === broadCastBackKeyCustomerAdd) {
        setStatus(Status.loading);
        Event.customerName = _value.name;
        await Event.addCustomer(_value.id as number);
        setStatus(Status.standard);
      }
      if (key === broadCastBackKeyCustomerLocationAdd) {
        setStatus(Status.loading);
        Event.customerLocationName = _value.name;
        Event.customerLocationId = _value.id;
        await Event.addCustomer(_value.id as number);
        setStatus(Status.standard);
      }
      if (key === broadCastBackKeySeminarAdd) {
        setStatus(Status.loading);
        console.log('SeminarAdd', _value);
        await Event.addUp(_value.id as number);
        setStatus(Status.standard);
      }
    }
  );
  function WarnMsg() {
    return <>
      {UserMsg &&
        <div
          className={`w3-border w3-border-yellow w3-padding`}
        >
          {UserMsg}
          <button
            onClick={() => {
              setUserMsg('');
            }}
            className={`w3-button w3-grey`}
          >OK</button>
        </div>}
    </>;
  }
  if (UserMsg) {
    return <div><WarnMsg /></div>;
  }
  if (status === Status.loading) {
    return <div
      className='EventPlaningDetails'
    >
      <Spinner />
    </div>;
  }
  console.log('Event', Event);
  return <>
    <div className='contentPart w3-row' id='eventSeminar'>
      <div className='w3-col s12 m12 l12'>
        <EditFieldsPrinter
          fields={Event.getEditFields(EventSpecificEditFieldsTopLeft)}
          item={Event}
          rerenderParent={() => {
            console.log('do rerender!')
            setRerender(rerender + 1)
          }}
        />
      </div>
      <div className='w3-col s12 m12 l12'>
        <EditFieldsPrinter
          fields={Event.getEditFields(EventSpecificEditFieldsTopRight)}
          item={Event}
          rerenderParent={() => {
            console.log('do rerender!')
            setRerender(rerender + 1)
          }}
        />
        <EditFieldsPrinter
          fields={Event.getEditFields(EventSpecificEditFieldsStatus)}
          item={Event}
          rerenderParent={() => {
            console.log('do rerender!')
            setRerender(rerender + 1)
          }}
        />
        <EditFieldsPrinter
          fields={Event.getEditFields(EventSpecificEditFieldsSubjects)}
          item={Event}
          rerenderParent={() => {
            console.log('do rerender!')
            setRerender(rerender + 1)
          }}
        />
      </div>
    </div>

    <div className='contentPart' id='eventTime'>
      <div className='contentHeader w3-margin-top'>
        <h2>Dauer{Event.getStartToEndDayCount()}</h2>
      </div>
      <div className='w3-padding'>
        <DateSelect event={Event} />
      </div>
    </div>

    <div className='contentPart' id='eventPrincipal'>
      <div className='contentHeader'>
        <h2>Auftraggeber*in</h2>
      </div>
      <PersonList
        eventId={Event.id}
        className=' '
        noSearch={true}
        rerenderTrigger={RerenderPersons}
        onRemove={async (id) => {
          await Event.removePerson(id, PersonKind.principal);
          setRerenderPersons(RerenderPersons + 1);
        }}
        personKind={PersonKind.principal} />
      <BroadcastRightButton
        contentType={RightDrawerContent.selectPerson}
        broadCastBackKey={broadCastBackKeyPrincipalAdd}
        title={`Auftraggeber*in wählen`}
        personKind={PersonKind.principal} />
    </div>

    <div className='contentPart' id='eventCustomer'>
      <div className='contentHeader'>
        <h2>Kunde</h2>
      </div>
      <div
        className='w3-padding pointer'
        onClick={() => {
          mainservice.navTo([['view', 'spCustomerEdit'], ['id', Event.customerId]])
        }}
      >{Event.customerName}</div>
      <BroadcastRightButton
        contentType={RightDrawerContent.selectCustomer}
        broadCastBackKey={broadCastBackKeyCustomerAdd}
        title={`Einem Unternehmen zuordnen`} />
    </div>

    <div className='contentPart' id='eventTrainer'>
      <PersonList
        headline="Trainer"
        eventId={Event.id}
        className=' '
        noSearch={true}
        rerenderTrigger={RerenderPersons}
        onRemove={async (id) => {
          await Event.removePerson(id, PersonKind.trainer);
          setRerenderPersons(RerenderPersons + 1);
        }}
        personKind={PersonKind.trainer}
        propTrainerTagParent={Event}
      />
      <BroadcastRightButton
        contentType={RightDrawerContent.selectTrainer}
        broadCastBackKey={broadCastBackKeyTrainerAdd}
        title={`Weiteren Trainer hinzufügen`}
        personKind={PersonKind.trainer} />
    </div>

    <div className='contentPart' id='eventLocation'>
      <div className='contentHeader'>
        <h2>Veranstaltungsort</h2>
      </div>
      <div className='w3-padding'>
        <LocationSelect
          Event={Event}
          shortInfo
          navClick
           />
      </div>
      <BroadcastRightButton
        contentType={RightDrawerContent.selectLocation}
        broadCastBackKey={broadCastBackKeyLocationAdd}
        title={`Veranstaltungsort einstellen`} />
    </div>

    <div className='contentPart' id='eventPerson'>
      <PersonList
        eventId={Event.id}
        className=' '
        noSearch={true}
        rerenderTrigger={RerenderPersons}
        onRemove={async (id) => {
          await Event.removePerson(id);
          setRerenderPersons(RerenderPersons + 1)
        }}
        headline="Teilnehmer*innen"
        personTagParent={Event}
        personKind={PersonKind.generic}
        selectAllButton={true}
      />
      <BroadcastRightButton
        contentType={RightDrawerContent.selectPerson}
        broadCastBackKey={broadCastBackKeyPersonAdd}
        title={`Teilnehmer*innen wählen`}
        personKind={PersonKind.generic} />
    </div>

  </>;
}
